import type { PresaleStage } from "../_types";

export const PRESALE_FOUNDERS = {
  names: "Steph, Chris & Ryan",
  role: "Founders",
} as const;

/** The "What happens next?" road map — Done / Next / Soon, deliberately without dates or a "Now". */
export function buildPresaleStages(placeLabel: string): PresaleStage[] {
  return [
    {
      label: "Done",
      status: "done",
      items: [
        {
          title: "Your spot is reserved",
          body: `Your Founding Membership is confirmed and ${placeLabel} is held in the launch group.`,
        },
      ],
    },
    {
      label: "Next",
      status: "current",
      items: [
        {
          title: "Virtual Onboarding",
          body: "You'll receive a message to complete your setup and onboarding in the app, and to schedule your onboarding call.",
        },
        {
          title: "Home Evaluation",
          body: "Then we visit. We'll walk through your home, document key systems and important details, and get a complete understanding of the property.",
        },
      ],
    },
    {
      label: "Soon",
      status: "upcoming",
      items: [
        {
          title: "HomeCare",
          body: "Once the evaluation is complete, we'll discuss your priorities and build a service plan personalized to your home.",
        },
        {
          title: "Services",
          body: "We schedule your first fix visit and services, and get to work on your home.",
        },
      ],
    },
  ];
}
